import { init } from "easy-analytics/client";
import { RouterProvider } from "easy-page-router";

import Router from "./Router";

// Initialize analytics. It sends data to our backend endpoint.
init(process.env.NODE_ENV === "development"
    ? "http://localhost:1111/api/easy-analytics"
    : "/api/easy-analytics");

export default function App() {
    return <RouterProvider>
        <Router />
    </RouterProvider>;
}
